<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-50">
      <restaurant-list
        v-bind:restaurants="restaurantList"
        v-on:addRestaurant="addRestaurant"
        v-on:viewRestaurant="viewRestaurant"
        v-on:deleteRestaurant="deleteRestaurant"
      ></restaurant-list>
    </div>
    <div class="md-layout-item md-size-50">
      <restaurant-tabs v-bind:restaurant="selectedRestaurant"></restaurant-tabs>
    </div>
  </div>
</template>

<script>
import restaurantApi from "@/services/api/restaurant";
import confirm from "@/helpers/deleteConfirm";

import _filter from "lodash/filter";
import _findIndex from "lodash/findIndex";

import RestaurantList from "./RestaurantList";
import RestaurantTabs from "./RestaurantTabs";

export default {
  components: {
    RestaurantList,
    RestaurantTabs
  },

  data() {
    return {
      selectedRestaurant: null,
      restaurantList: []
    };
  },

  methods: {
    getRestaurants() {
      restaurantApi.getRestaurants().then(response => {
        this.restaurantList = response.data;
      });
    },

    addRestaurant() {
      this.selectedRestaurant = {};
    },

    viewRestaurant(restaurant) {
      this.selectedRestaurant = { ...restaurant };
    },

    deleteRestaurant(restaurant) {
      confirm.delete(null).then(resp => {
        if (resp.value) {
          restaurantApi.deleteRestaurant(restaurant.id).then(response => {
            this.restaurantList = _filter(this.restaurantList, function(r) {
              return r.id !== restaurant.id;
            });

            this.$notify({
              timeout: 2500,
              message: "Deleted.",
              icon: "cancel",
              horizontalAlign: "center",
              verticalAlign: "top",
              type: "danger"
            });
          });
        }
      });
    },

    restaurantUpdated(updateInfo) {
      if (updateInfo.mode == "CREATE") {
        this.restaurantList.unshift(updateInfo.restaurant);
      } else {
        var index = _findIndex(this.restaurantList, {
          id: updateInfo.restaurant.id
        });
        this.restaurantList.splice(index, 1, updateInfo.restaurant);
      }

      this.selectedRestaurant = null;
    }
  },

  mounted() {
    this.getRestaurants();
  }
};
</script>
